import Main from 'layouts/Main';
import { SymposiumSchedule } from './components';

const Symposium = () => {
    return (
        <Main>
            <SymposiumSchedule />
        </Main>
    );
};

export default Symposium;
